import { useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { openModal } from '../../../actions/ModalActions';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { MODAL_TYPES } from '../../../constants/ModalConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreateVariationMenuAction = ({
  contentId
}) => {
  const dispatch = useDispatch();
  const handleCreateVariation = () => {
    dispatch(openModal(MODAL_TYPES.GENERATE_WITH_AI, {
      contentIdForVariation: contentId
    }));
  };
  return /*#__PURE__*/_jsxs(Button, {
    onClick: handleCreateVariation,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "actionMenu.createVariation"
    }), /*#__PURE__*/_jsx(Badge, {
      use: "beta",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "actionMenu.badge.beta"
      })
    })]
  });
};
export default CreateVariationMenuAction;